// extracted by mini-css-extract-plugin
export default {"rightSectionMobile":"RightSectionMobile_rightSectionMobile__NM3J0"};